module.exports = __webpack_public_path__ + "videos/2.410eb59.mp4";